import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

export default function SwitchLogin() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => {
    const token = params.get("token") || "";
    const target = params.get("to") || "/";
    if (!token) {
      toast.error("Login switch token missing");
      nav("/", { replace: true });
      return;
    }

    sessionStorage.setItem("access_token", token);
    sessionStorage.setItem("impersonated_by_admin", "true");
    window.location.replace(target.startsWith("/") ? target : "/");
  }, [nav, params]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-sm font-mono uppercase tracking-widest text-[#6B7280]">Opening panel...</div>
    </div>
  );
}
